//@config
export default {
  research: {
    research_queue: "v1/research_queue",
    assignResearcher: "v1/assign_researcher",
    researchQueueId: "v1/research_queue/{0}",
    researchManagerConfirm: "v1/research_queue/{0}/research_manager_confirm",
    azmoon_execute:
      "v1/azmoon-execute/{0}/person/{1}/operator/{2}/reference/{3}",
    researchManager: "v1/research_manager",
    researchQueuePlan: "v1/research_queue/{0}/plan",
    researchQueuePlanDetail: "v1/research_queue/{0}/plan/{1}",
    readyResearch: "v1/ready_research",
    connectResearchManagerAudience: "v1/research_manager_audience",
    myResearchQueue: "v1/my-research-queue",
    researchCompleted: "v1/research_queue/{0}/complete",
    importResearchManagerResearcher: "v1/import-research-manager-researcher",
    fa: {
      myResearcher: "v1/fa/research/my-researcher",
      researchManager: "v1/fa/research/research-manager",
      researcher: "v1/fa/research/research-manager/{0}/researcher",
      researcherCode: "v1/fa/research/research-manager/{0}/researcher/{1}",
      researchAttachments: "v1/fa/research/attachment-research/{0}",
      researchAttachment:
        "v1/fa/research/attachment-research/{0}/attachment/{1}",
    },
    en: {
      researchAttachments: "v1/en/research/attachment-research/{0}",
      researchAttachment:
        "v1/en/research/attachment-research/{0}/attachment/{1}",
    },
  },
};
